import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type BarContextValue = {
    isRunning: boolean;
    isStopped: boolean;
    isActive: boolean;
};

type BarContextProviderProps = {
    isRunning: boolean;
    isStopped: boolean;
    isActive: boolean;
    children: ReactNode;
};

export const BarContext = createContext<BarContextValue | undefined>(undefined);

export const BarContextProvider = ({
    isRunning,
    isStopped,
    isActive,
    children
}: BarContextProviderProps) => {
    return (
        <BarContext.Provider
            value={{
                isRunning: isRunning,
                isStopped: isStopped,
                isActive: isActive
            }}
        >
            {children}
        </BarContext.Provider>
    );
};

export const useBarContext = () => {
    const context = use<BarContextValue | undefined>(BarContext);

    if (!isDefined(context)) {
        throw new Error(`${BarContext.displayName} is undefined.`);
    }

    return context;
};
